@if (!asstes) {
	<span #dcIcon class="dc-icon flex h-full w-full items-center justify-center">
		<i [ngClass]="iconClass" [ngStyle]="iconStyles"></i>
	</span>
} @else {
	@if (svgLoaded) {
		<mat-icon [svgIcon]="activeSvg$ | async" />
	}
}
